<template>
  <global-tag>
    <el-form
      class="queryForm"
      ref="queryForm"
      :model="queryForm"
      label-width="120px"
    >
      <el-row>
        <el-col :span="5">
          <el-form-item label="客户姓名：">
            <el-input
              clearable
              v-model="queryForm.customerName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="用户类型：">
            <el-select
              v-model="queryForm.customerUserType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="(item, index) in userType"
                :key="index"
                :label="item.dictLabel"
                :value="item.dictCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="服务项目：">
            <el-select
              v-model="queryForm.serveproductName"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in product"
                :key="item.id"
                :label="item.serviceProductName"
                :value="item.id + ''"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="5">
          <el-form-item label="机构：">
            <el-select
              v-model="queryForm.servestationName"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in serviceStationList"
                :key="item.id"
                :label="item.statName"
                :value="item.statName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
         <el-col :span="5">
           <el-form-item label="服务类型：">
            <el-select
              v-model="queryForm.serviceTypeName"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in serviceTypeList"
                :key="item.id"
                :label="item.serviceTypeName"
                :value="item.serviceTypeName"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="服务人员：">
            <el-input
              clearable
              v-model="queryForm.servePersonName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="工单号：">
            <el-input
              clearable
              v-model="queryForm.orderNum"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="14">
          <el-form-item label="服务时间：">
            <el-date-picker
              v-model="queryForm.timeStart"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              type="datetime"
              placeholder="请输入开始时间"
            ></el-date-picker>
            <span style="margin: 0 5px">至</span>
            <el-date-picker
              v-model="queryForm.timeEnd"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              type="datetime"
              placeholder="请输入结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="18" v-if="queryForm.finish == 1">
          <el-form-item>
            <span>当月老人工单数大于</span>
            <el-input
              style="width: 25%; margin: 0 5px"
              v-model="queryForm.startCount"
              placeholder="请输入"
              type="number"
            ></el-input
            >次，并且小于<el-input
              v-model="queryForm.endCount"
              style="width: 25%; margin: 0 5px"
              type="number"
              @blur="Count"
              placeholder="请输入"
            ></el-input
            >次工单
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="地址：">
            <el-select
              v-model="queryForm.provinceId"
              placeholder="请选择省"
              @change="handleProvince"
              ref="selectShengChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.cityid"
              placeholder="请选择市"
              @change="handleCity"
              ref="selectShiChange"
              class="address"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.zoneid"
              placeholder="请选择区"
              @change="handleArea"
              ref="selectQuChange"
              class="address"
            >
              <el-option
                v-for="item in areaList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.streetid"
              placeholder="请选择街道"
              @change="streetChange"
              ref="selectJiedaoChange"
              class="address"
            >
              <el-option
                v-for="item in streetList"
                :key="item.addCode"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryForm.shequid"
              placeholder="请选择社区"
              ref="selectShequChange"
              @change="handleCommunityChange"
              class="address"
            >
              <el-option
                v-for="item in communityList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" class="QuerySearchBtn">
          <el-button
            size="medium"
            class="searchBtns"
            type="primary"
            @click="QuerySearch"
            >查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
  </global-tag>
</template>
<script>
import request from "@/utils/request"
import globalTag from "@/component/globalTag"

export default {
  name: "queryForm",
  components: { globalTag },
  props: {
    queryForm: {
      type: Object,
    },
  },
  data() {
    return {
      //客户下拉框的值
      options: [
        {
          value: "7",
          label: "商业客户",
        },
        {
          value: "3",
          label: "残联客户",
        },
        {
          value: "4",
          label: "老干客户",
        },
        {
          value: "6",
          label: "民政客户",
        },
        {
          value: "10",
          label: "文明办客户",
        },
      ],
       serviceTypeList:[
      ],
      product: [],
      serviceStationList: [],
      serviceStaffList: [],
      userType: [],
      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: [],
    }
  },
  created() {
    this.getTableData()
    this.getServiceStationList()
    //  this.getServiceStaffList()
    this.getusertypeList()
    this.getProvince()
    this.getTypeList()
  },
  methods: {
    //获取服务类别
    getTypeList(){
       request({
        url: "/jjyl/admin/type/info/findList1",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 9999,
          states: "1",
        },
      }).then((res) => {
        if (res.code === 200 && res.content) {
          const arr = res.content || []
          this.serviceTypeList=res.content
        }
      })
    },
    //获取用户类型
    getusertypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "usertype",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.userType = res.rows
            }
          }
        })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      // console.log(this.provinceList)
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.cityid = ""
      this.queryForm.zoneid = ""
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      let city = await this.getDistricts(val)
      // console.log(val, this.queryForm.provinceId)
      this.queryForm.servicePgdAddress = this.queryForm.provinceId

      this.cityList = city.districtList
      // console.log(this.cityList)
    },
    //市级地址发生改变
    async handleCity(val) {
      // console.log(val, "qu")
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.queryForm.zoneid = ""
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      let area = await this.getStreetList(val)
      this.queryForm.servicePgdAddress =
        this.queryForm.provinceId + "-" + this.queryForm.cityid
      this.areaList = area
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.queryForm.streetid = ""
      this.queryForm.shequid = ""
      // val = val.replace(/.$/, "");
      this.queryForm.servicePgdAddress =
        this.queryForm.provinceId +
        "-" +
        this.queryForm.cityid +
        "-" +
        this.queryForm.zoneid
      // console.log(this.queryForm.servicePgdAddress)
      let street = await this.getStreetList(val)
      // console.log(1111, this.queryForm.zoneid, val)

      this.streetList = street
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      // console.log(val)
      this.streetList.forEach((item) => {
        if (item.addName == val) {
          // console.log(item, item.addCode)
          this.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                jiedaoId: item.addCode,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  return
                } else {
                  this.communityList = res.content
                }
              }
            })
        }
      })
    },
    //街道地址发生变化
    async streetChange(val) {
      // console.log(val)
      this.queryForm.shequid = ""
      this.communityList = await this.getStreetList(val)
      // console.log(1111, this.queryForm.streetid)
      this.queryForm.servicePgdAddress =
        this.queryForm.provinceId +
        "-" +
        this.queryForm.cityid +
        "-" +
        this.queryForm.zoneid +
        "-" +
        this.queryForm.streetid

      // console.log(this.queryForm.servicePgdAddress)
      // console.log(this.communityList)
    },
    // 社区
    handleCommunityChange(val) {
      // console.log(val)
      this.queryForm.servicePgdAddress =
        this.queryForm.provinceId +
        "-" +
        this.queryForm.cityid +
        "-" +
        this.queryForm.zoneid +
        "-" +
        this.queryForm.streetid +
        "-" +
        val
      // console.log(1111, this.queryForm.communityName)
      // console.log(this.queryForm.shequid)
      // console.log(this.queryForm.servicePgdAddress)
      this.$nextTick(() => {
        this.$forceUpdate()
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
    Count() {
      if (this.queryForm.endCount < this.queryForm.startCount) {
        this.queryForm.endCount = ""
        this.$message("后者输入的次数应大于前者")
      }
    },
    QuerySearch() {
      let aa = this.queryForm.endCount - this.queryForm.startCount
      if (aa < 2) {
        this.queryForm.startCount = ""
        this.queryForm.endCount = ""
        this.$message("两次输入的次数不能连续")
      }
      this.$emit("QuerySearch")
    },

    // 获取项目列表数据
    getTableData() {
      this.$http
        .request({
          url: "/jjyl/admin/product/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 999,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (!res.content) {
              this.product = []
              this.pageConfig.total = 0
            } else {
              this.product = res.content.list || []
            }
          }
        })
    },
    // 机构
    getServiceStationList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
      }
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceStationList = res.content.list || []
          } else {
            this.serviceStationList = []
          }
        }
      })
    },
    // 人员
    // 获取表格数据
    getServiceStaffList() {
      let params = {
        pageNo: 1,
        pageSize: 999,
        serviceStationName: this.queryForm.servestationName,
        // ...this.query,
      }
      this.$http
        .request({
          url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.serviceStaffList = []
              return
            }
            this.serviceStaffList = res.content.list
          }
        })
    },
  },
}
</script>
<style lang="less" scoped>
.QuerySearchBtn {
  margin-left: 60px;
}
.address {
  width: 170px !important;
  margin-right: 3px;
}
</style>
